module.exports = "/images/zink-logo-colour-white.png?ab012f2b5fb81b240400a62d03ebeb05";